import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
    renderField,
    required,
    renderToggle,
    renderTextArea,
    json,
    renderSelectField
} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import {getStorageProviders } from "../../../actions/actionStorageProvider";
import {withTranslation} from "react-i18next";
import { Groups, Group, FormFooter } from "../../../components/Form"
import { baseUrl } from '../../../utils/helpers.js';

class StorageProviderConfigFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentStorageProvider: {},
            collapseAdvanced: false,
            urlField: "",
            redirect_url: baseUrl() + "api/cloud_storage_callback",
        };
        this.handleUrlChange = this.handleUrlChange.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);
        this.changeType = this.changeType.bind(this);
    }

    changeType(e) {

        this.props.autofill('webdav_url', undefined)
        this.props.autofill('auth_url', undefined)
        this.props.autofill('auth_url_options', undefined)
        this.props.autofill('token_url', undefined)
        this.props.autofill('scope', undefined)
        this.props.autofill('volume_config', undefined)
        this.props.autofill('mount_config', undefined)
        this.props.autofill('root_drive_url', undefined)
        this.props.autofill('redirect_url', undefined)
        this.props.autofill('default_target', undefined)
        this.props.autofill('client_id', undefined)
        this.props.autofill('client_secret', undefined)

        switch (e.target.value) {
            case "Nextcloud": 
                this.props.change('webdav_url', 'https://<hostname>:<port>/remote.php/dav/files/')
                this.props.change('default_target', '/nextcloud')
                this.props.change('mount_config', '{}')
                this.props.change('volume_config', '{\n\t"driver" : "rclone",\n\t"driver_opts" : {\n\t\t"type" : "webdav",\n\t\t"webdav-vendor" : "nextcloud",\n\t\t"uid" : "1000",\n\t\t"gid" : "1000",\n\t\t"allow_other" : "true"\n\t}\n}')
            break;
            case "Dropbox":
                this.props.change('auth_url', 'https://www.dropbox.com/1/oauth2/authorize')
                this.props.change('auth_url_options', '{\n\t"include_granted_scopes" : "user",\n\t"access_type" : "offline",\n\t"token_access_type" : "offline"\n}')
                this.props.change('token_url', 'https://api.dropboxapi.com/1/oauth2/token')
                this.props.change('redirect_url', 'https://<hostname>/api/cloud_storage_callback')
                this.props.change('default_target', '/dropbox')
                this.props.change('mount_config', '{}')
                this.props.change('volume_config', '{\n\t"driver" : "rclone",\n\t"driver_opts" : {\n\t\t"type" : "dropbox",\n\t\t"uid" : "1000",\n\t\t"gid" : "1000",\n\t\t"allow_other" : "true"\n\t}\n}')
                this.props.change('scope', 'files.metadata.read\nfiles.metadata.write\nfiles.content.read\nfiles.content.write\nsharing.read\nsharing.write\naccount_info.read')
            break;
            case "Google Drive":
                this.props.change('auth_url', 'https://accounts.google.com/o/oauth2/auth')
                this.props.change('auth_url_options', '{\n\t"include_granted_scopes" : "true",\n\t"prompt" : "select_account consent",\n\t"access_type" : "offline"\n}')
                this.props.change('token_url', 'https://oauth2.googleapis.com/token')
                this.props.change('redirect_url', 'https://<hostname>/api/cloud_storage_callback')
                this.props.change('default_target', '/gdrive')
                this.props.change('mount_config', '{}')
                this.props.change('volume_config', '{\n\t"driver" : "rclone",\n\t"driver_opts" : {\n\t\t"type" : "drive",\n\t\t"uid" : "1000",\n\t\t"gid" : "1000",\n\t\t"allow_other" : "true"\n\t}\n}')
                this.props.change('scope', 'https://www.googleapis.com/auth/drive')
            break;
            case "OneDrive":
                this.props.change('auth_url_options', '{\n\t"prompt" : "consent"\n}')
                this.props.change('redirect_url', 'https://<hostname>/api/cloud_storage_callback')
                this.props.change('default_target', '/onedrive')
                this.props.change('mount_config', '{}')
                this.props.change('volume_config', '{\n\t"driver" : "rclone",\n\t"driver_opts" : {\n\t\t"type" : "onedrive",\n\t\t"uid" : "1000",\n\t\t"gid" : "1000",\n\t\t"allow_other" : "true"\n\t}\n}')
                this.props.change('scope', 'Files.Read\nFiles.ReadWrite\nFiles.Read.All\nFiles.ReadWrite.All\nSites.Read.All\noffline_access\nopenid\nemail\nprofile')
            break;
            case "S3":
                this.props.change('default_target', '/s3')
                this.props.change('mount_config', '{}')
                this.props.change('volume_config', '{\n\t"driver" : "rclone",\n\t"driver_opts" : {\n\t\t"type" : "s3",\n\t\t"s3-provider" : "AWS",\n\t\t"s3-env-auth" : "false",\n\t\t"s3-region" : "us-east-1",\n\t\t"uid" : "1000",\n\t\t"gid" : "1000",\n\t\t"allow_other" : "true"\n\t}\n}')
            break;
            case "Custom":
                this.props.change('default_target', '/custom')
                this.props.change('mount_config', '{}')
                this.props.change('volume_config', '{\n\t"driver" : "rclone",\n\t"driver_opts" : {\n\t\t"type" : "s3",\n\t\t"s3-provider" : "AWS",\n\t\t"s3-env-auth" : "false",\n\t\t"s3-access-key-id" : "--enter id here--",\n\t\t"s3-secret-access-key" : "--enter key here--",\n\t\t"s3-region" : "us-east-1",\n\t\t"uid" : "1000",\n\t\t"gid" : "1000",\n\t\t"allow_other" : "true"\n\t}\n}')
            break;
            case "Kasm OverlayFS":
                this.props.change('volume_config', '{\n\t\t"backend_storage" : "s3",\n\t\t"per-user-encryption" : false,\n\t\t"cache-layers-disk-usage" : "50%",\n\t\t"layer-limit" : 10,\n\t\t"snapshots" : 0\n}')
                this.props.change('mount_config', '{}')
                this.props.change('default_target', '/home')
        }
    }

    toggleAdvanced() {
        this.setState({collapseAdvanced: !this.state.collapseAdvanced})
    }

    handleUrlChange(e) {
        this.setState({urlField: e.target.value});
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.storage_providers && nextProps.storage_providers.length > 0 && this.props.storage_providers !== nextProps.storage_providers && this.props.fromUpdate){
            let currentStorageProvider = nextProps.storage_providers.find(oidc => oidc.storage_provider_id === this.props.storageProviderId);
            this.setState({currentStorageProvider: currentStorageProvider, urlField : currentStorageProvider && currentStorageProvider.key ? currentStorageProvider.key : ''});
            this.props.initialize({
                storage_provider_id: currentStorageProvider.storage_provider_id,
                storage_provider_type: currentStorageProvider.storage_provider_type,
                client_id: currentStorageProvider.client_id,
                client_secret: currentStorageProvider.client_secret,
                auth_url: currentStorageProvider.auth_url,
                token_url: currentStorageProvider.token_url,
                webdav_url: currentStorageProvider.webdav_url,
                scope: currentStorageProvider.scope ? currentStorageProvider.scope.join('\n') : '',
                redirect_url: currentStorageProvider.redirect_url,
                auth_url_options: currentStorageProvider.auth_url_options ? JSON.stringify(currentStorageProvider.auth_url_options, null, 2) : '',
                volume_config: currentStorageProvider.volume_config ? JSON.stringify(currentStorageProvider.volume_config, null, 2) : '',
                mount_config: currentStorageProvider.mount_config ? JSON.stringify(currentStorageProvider.mount_config, null, 2) : '',
                root_drive_url: currentStorageProvider.root_drive_url,
                default_target: currentStorageProvider.default_target,
                enabled: currentStorageProvider.enabled,
                name: currentStorageProvider.name,
            });
        }
    }

    componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getStorageProviders();
        }
    }


    render() {
        const {handleSubmit, storageProviderFormValues, t} = this.props;
        const {redirect_url } = this.state;

        const helpSuffix = () => {
            switch(storageProviderFormValues?.storage_provider_type) {
                case 'Custom':
                    return '-1'
                case 'Dropbox':
                    return '-2'
                case 'Google Drive':
                    return '-3'
                case 'Nextcloud':
                    return '-4'
                case 'OneDrive':
                    return '-5'
                case 'S3':
                    return '-6'
                case 'Kasm OverlayFS':
                    return '-7'
            }
            return ''
        }
        
        return (
            <Groups onSubmit={handleSubmit(this.props.save)} section={this.props.section}>
                <Group title="general" description="general-description">
                    <Field name="enabled"
                        id="enabled"
                        type="checkbox"
                        help="kb-8-1"
                        component={renderToggle}
                    />
                    <Field type="text"
                        name="name"
                        id="name"
                        component={renderField}
                        validate={required} required
                    />
                    <Field type="text"
                        name="storage_provider_type"
                        id="storage_provider_type"
                        component={renderSelectField}
                        clearable={false}
                        help="kb-8-2"
                        selectedValue={storageProviderFormValues && storageProviderFormValues.storage_provider_type || "Dropbox"}
                        disabled={!!this.props.fromUpdate}
                        onChange={this.changeType}
                        validate={required} required>
                        <option value="">{"Select"}</option>
                        <option value='Custom'>{"Custom"}</option>
                        <option value='Dropbox'>{"Dropbox"}</option>
                        <option value='Google Drive'>{"Google Drive"}</option>
                        <option value='Nextcloud'>{"Nextcloud"}</option>
                        <option value='OneDrive'>{"OneDrive"}</option>
                        <option value='S3'>{"S3"}</option>
                    </Field>
                    <Field type="text"
                        name="default_target"
                        help="kb-8-3"
                        id="default_target"
                        component={renderField}
                        validate={required} required
                        disabled={storageProviderFormValues && storageProviderFormValues.storage_provider_type === "Kasm OverlayFS"}
                    />
                </Group>


                {storageProviderFormValues && ["Google Drive", "Dropbox", "OneDrive", "Nextcloud"].includes(storageProviderFormValues.storage_provider_type) && (
                    <Group title="provider-details" description="provider-details-description">
                        <React.Fragment>


                            {storageProviderFormValues && ["Google Drive", "Dropbox", "OneDrive"].includes(storageProviderFormValues.storage_provider_type) && (
                                <React.Fragment>
                                    <Field type="text"
                                        name="client_id"
                                        id="client_id"
                                        help={'kb-8-5'}
                                        helpSuffix={helpSuffix()}
                                        component={renderField}
                                        validate={required} required
                                    />
                                    <Field type="password"
                                        name="client_secret"
                                        id="client_secret"
                                        help={'kb-8-6'}
                                        helpSuffix={helpSuffix()}
                                        component={renderField}
                                        validate={required} required
                                    />
                                    <Field type="text"
                                        name="auth_url"
                                        id="auth_url"
                                        help={'kb-8-7'}
                                        helpSuffix={helpSuffix()}
                                        component={renderField}
                                        validate={required} required
                                    />
                                    <Field type="textarea"
                                        name="auth_url_options"
                                        id="auth_url_options"
                                        help={'kb-8-8'}
                                        helpSuffix={helpSuffix()}
                                        component={renderTextArea}
                                        validate={[json, required]} required
                                    />
                                    <Field type="text"
                                        name="token_url"
                                        id="token_url"
                                        help={'kb-8-9'}
                                        helpSuffix={helpSuffix()}
                                        component={renderField}
                                        validate={required} required
                                    />
                                    <Field type="text"
                                        name="redirect_url"
                                        id="redirect_url"
                                        help={'kb-8-10'}
                                        helpSuffix={helpSuffix()}
                                        component={renderField}
                                        placeholder={redirect_url}
                                        validate={required} required
                                    />
                                    <Field type="textarea"
                                        name="scope"
                                        id="scope"
                                        help={'kb-8-11'}
                                        helpSuffix={helpSuffix()}
                                        component={renderTextArea}
                                        validate={required} required
                                    />
                                </React.Fragment>
                            )}
                            {storageProviderFormValues && ["OneDrive"].includes(storageProviderFormValues.storage_provider_type) && (
                                <Field type="text"
                                    name="root_drive_url"
                                    id="root_drive_url"
                                    help={'kb-8-12'}
                                    component={renderField}
                                    validate={required} required
                                />
                            )}
                            {storageProviderFormValues && ["Nextcloud"].includes(storageProviderFormValues.storage_provider_type) && (
                                <React.Fragment>
                                    <Field type="text"
                                        name="webdav_url"
                                        id="webdav_url"
                                        help={'kb-8-13'}
                                        component={renderField}
                                        validate={required} required
                                    />

                                </React.Fragment>

                            )}



                        </React.Fragment>
                    </Group>
                    )}


                {storageProviderFormValues && storageProviderFormValues.storage_provider_type && (
                <Group title="volume" description="volume-description">
                    <Field type="textarea"
                        name="volume_config"
                        id="volume_config"
                        help={'kb-8-4'}
                        helpSuffix={helpSuffix()}
                        component={renderTextArea}
                        validate={[json, required]} required
                    />
                
                {storageProviderFormValues && storageProviderFormValues.storage_provider_type && storageProviderFormValues.storage_provider_type !== "Kasm OverlayFS" && (
                    <Field type="textarea"
                        name="mount_config"
                        id="mount_config"
                        help={'kb-8-14'}
                        component={renderTextArea}
                        validate={[json, required]} required
                    />
                )}
                </Group>
                )}
                


                 <FormFooter cancel={() => this.props.history.push("/storage_providers")} />
            </Groups>
        );
    }
}

StorageProviderConfigFormTemplate.proptypes = {
    createStorageProvider: Proptypes.func,
    updateStorageProvider: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let StorageProviderConfigFormWithRouter = withRouter(StorageProviderConfigFormTemplate);


const selector = formValueSelector('StorageProviderConfigForm');

let StorageProviderConfigForm =  connect(state =>{


            return {
                createStorageProviderError: state.storage_provider.createStorageProviderError,
                updateStorageProviderLoading: state.storage_provider.updateStorageProviderLoading,
                updateStorageProviderError: state.storage_provider.updateStorageProviderError,
                storage_providers: state.storage_provider.storage_providers || [],
                storageProviderFormValues: state.form && state.form.StorageProviderConfigForm && state.form.StorageProviderConfigForm.values ? state.form.StorageProviderConfigForm.values : null,

            }
    },

    dispatch =>
        ({
            getStorageProviders: () => dispatch(getStorageProviders()),
        }))(StorageProviderConfigFormWithRouter);
        const StorageProviderConfigFormTranslated = withTranslation('common')(StorageProviderConfigForm)
export default reduxForm({
    form: "StorageProviderConfigForm",
    initialValues: { enabled: true },
})(StorageProviderConfigFormTranslated);